<template>
    <nav v-if="footerItems.length" :class="classes">
        <div class="footer-nav__top" v-for="item in footerItems">
            <h5>{{ item.name }}</h5>
            <div class="footer-nav__bottom">
                <div v-for="child in item.children">
                    <a :href="link(child)">
                        {{ child?.translated?.name || child.name }}
                    </a>
                </div>
            </div>
        </div>
    </nav>
</template>
<script>
import { defineComponent, unref } from 'vue';
import { useAppStore } from '@stores/App';
import BreakpointDemo from '@components/BreakpointDemo.vue';
import Accordion from '@components/Accordion.vue';
export default defineComponent({
    components: { Accordion, BreakpointDemo },
    data() {
        const app = useAppStore();
        return {
            app: app,
            footerItems: [],
        };
    },
    mounted() {
        this.footerItems = this.app.getFooterNavigation();
    },
    computed: {
        classes() {
            const app = useAppStore();
            return ['footer-nav', unref(this.app.getBreakpoints().active()), app.theme];
        },
    },
    methods: {
        link(item) {
            return this.app.getNavLink(item);
        }
    },
});
</script>
<style lang="scss" scoped>
.footer-nav {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    color: var(--theme-title-color);
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
    transition: background-color var(--transition-duration), color var(--transition-duration);

    a {
        color: inherit;
        position: relative;
        font-size: 16px;
        font-family: Optima, serif;
        font-weight: 400;
        line-height: 40px;
        text-decoration: none;
    }

    h5 {
        width: 100%;
        margin-top: 0;
        font-family: Chronicle, serif;
        font-weight: 400;
        line-height: 28px;
    }

    &__top {
        margin-bottom: 20px;
        width: 100%;
        max-width: none;
    }

    &.sm {
        grid-template-columns: 1fr;
    }

    .sm & {
        margin-top: 30px;
        text-align: center;

        &__top {
            margin-bottom: 30px;
        }
    }
}
</style>
